<template>
  <div class="d-flex justify-content-between">
    <span class="semibold">€{{ start?.toLocaleString(lang) }}</span>
    <span class="semibold">€{{ end?.toLocaleString(lang) }}</span>
  </div>
  <VueSlider
    v-model="selected"
    v-bind="sliderOptions"
    :min="minValue"
    :max="maxValue"
    :interval="configuration.priceInterval"
    :disabled="disabled"
    :tooltip-formatter="(val) => `€${val.toLocaleString(lang)}`"
    @change="onChange" />
</template>

<script>
import * as lib from '../../../lib/lib'
import mixinsLeaseItNow from './../../mixins/leaseitnow-mixins'
/* eslint-disable no-unused-vars */
import { max, min } from 'lodash'
import VueSlider from 'vue-slider-component'
import constants from './../../../lib/constants'
const { filters } = constants.leaseitnow

export default {
  components: { VueSlider },
  mixins: [mixinsLeaseItNow],
  props: {
    minValue: {
      required: true,
      type: Number,
    },
    maxValue: {
      required: true,
      type: Number,
    },
    disabled: {
      required: false,
      type: Boolean,
    },
  },
  emits: ['change-selected'],
  data() {
    return {
      lang: 'en',
      sliderOptions: {
        lazy: true,
        duration: null,
        height: 10,
        contained: true,
      },
    }
  },
  computed: {
    selected: {
      get: function () {
        return this.getField(filters.prices)
      },
      set: function (value) {
        this.setField({ field: filters.prices, value })
      },
    },

    start() {
      return this.selected[0]
    },

    end() {
      return this.selected[1]
    },
  },
  mounted() {
    this.lang = lib.getLocaleFromLangAttr()
  },
  methods: {
    onChange() {
      this.$nextTick(() => {
        this.$emit('change-selected')
      })
    },
  },
}
</script>
